// Bucket-first campaign reader, including catalog shells and legacy top-level scalars.
export function _ftCamField(arr: { campaigns?: { [k: string]: unknown }; [k: string]: unknown } | null | undefined, key: string): string | undefined {
    if (!arr) return undefined;
    const bucket = arr.campaigns;
    let value: unknown = bucket && typeof bucket === 'object' && key in bucket ? bucket[key] : arr[key];
    // PHP campaign_field selects the bucket, unwraps [0], then unwraps the catalog shell.
    if (Array.isArray(value)) value = value[0];
    if (value && typeof value === 'object') {
        const items = (value as { items?: { item_id?: unknown } }).items;
        if (items && typeof items.item_id === 'string') value = items.item_id;
    }
    return value == null ? undefined : String(value);
}
